import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";

const TABS = [
  { id: "franchise", label: "Franchise", to: "/franchise/onboard", blurb: "Run a district cluster — School + Store + Academies under one operator." },
  { id: "schools", label: "Schools", to: "/onboard", blurb: "Launch your school's fully-isolated ERP portal with fees, LMS & messaging." },
  { id: "stores", label: "Stores", to: "/vendor/onboard", blurb: "List your merchant storefront district-wide with COD & take-rate pricing." },
  { id: "tv", label: "TV / Academies", to: "/creator/onboard", blurb: "Broadcast board-aligned content and academy streams on Ponderr TV." },
  { id: "students", label: "Students", to: "/open-school/onboard", blurb: "Join Open School directly — 90-day free trial, no card required." },
];

export default function TabbedOnboarding() {
  const [tab, setTab] = useState("students");
  const [open, setOpen] = useState(false);
  const active = TABS.find(t => t.id === tab);

  return (
    <section id="onboarding" className="max-w-7xl mx-auto px-6 py-10" data-testid="tabbed-onboarding">
      <h2 className="display text-3xl font-bold mb-4">Join Ponderr</h2>
      <div className="flex flex-nowrap overflow-x-auto no-scrollbar gap-2 mb-4">
        {TABS.map(t => (
          <button key={t.id} onClick={() => { setTab(t.id); setOpen(false); }} data-testid={`onboard-tab-${t.id}`}
            className={`pf-btn shrink-0 text-sm ${tab === t.id ? "" : "!bg-transparent !shadow-none"}`}>{t.label}</button>
        ))}
      </div>
      <div className="nb-card p-6 pf-surface border-2 pf-border">
        <p className="text-base pf-text">{active.blurb}</p>
        <button onClick={() => setOpen(v => !v)} data-testid="onboard-toggle-form"
          className="pf-btn mt-4 text-sm flex items-center gap-1">
          Open Application Form <ChevronDown size={15} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
        {open && (
          <div className="mt-4 border-t-2 pf-border pt-4" data-testid="onboard-form-panel">
            <p className="text-sm pf-muted mb-3">Continue to the {active.label} application to complete your details.</p>
            <Link to={active.to} className="pf-btn inline-flex text-sm" data-testid={`onboard-cta-${active.id}`}>
              Start {active.label} Application <ArrowRight size={15} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
